import { List } from "@material-ui/core";
import React from "react";
import { structure } from "../../description/header.description";
import HeaderLinks from "./HeaderLinks";

function HeaderNavbar() {
  return (
    <List
      style={{
        display: "flex",
        justifyContent: "flex-end",
      }}
    >
      {structure.map((link, ind) => (
        <HeaderLinks key={ind} {...link} />
      ))}
    </List>
  );
}

export default HeaderNavbar;
